import { erpAxios } from '..';

const getClientTipoviDokumenata = async () => {
  const { data } = await erpAxios(`/dokumenti/clientTipovi`);
  return data;
};

export default getClientTipoviDokumenata;
